import { VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';
import {
  AfterViewChecked,
  ContentChild,
  Directive,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { MatTable } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { CoreTableDataSource } from '../../../extensions/virtual-scroll/core-table-data-source';
import { CoreTableVirtualScrollStrategy } from '../../../extensions/virtual-scroll/core-table-virtual-scroll-strategy';

@Directive({
  selector: 'cdk-virtual-scroll-viewport[coreTableVirtualScroll]',
  providers: [
    {
      provide: VIRTUAL_SCROLL_STRATEGY,
      useFactory: (scroll: CoreTableFixedVirtualScrollDirective) => scroll.scrollStrategy,
      deps: [forwardRef(() => CoreTableFixedVirtualScrollDirective)],
    },
  ],
  standalone: true,
})
export class CoreTableFixedVirtualScrollDirective
  implements OnChanges, OnDestroy, AfterViewChecked
{
  @Input() rowHeight = 48;
  @Input() offset = 56;

  @ContentChild(MatTable) table: MatTable<any>;

  scrollStrategy: CoreTableVirtualScrollStrategy;

  private sub: Subscription;

  constructor() {
    this.scrollStrategy = new CoreTableVirtualScrollStrategy(this.rowHeight, this.offset);
  }

  /**
   * AfterViewChecked runs every change detection cycle. The dataSource might not be initialized
   * in AfterViewInit so we need to check it here.
   */
  ngAfterViewChecked(): void {
    if (!this.sub) {
      if (this.table && this.table.dataSource instanceof CoreTableDataSource) {
        this.sub = this.table.dataSource.filteredData.subscribe((data) => {
          this.scrollStrategy.setDataLength(data.length);
        });
      }
    }
  }

  ngOnChanges() {
    this.scrollStrategy.setScrollHeight(this.rowHeight, this.offset);
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
